import { toast } from 'react-toastify';
import { Uuid } from '@/api/types';
import { retrieveUnifiedError } from '@/api/utils';
import { useRemoveOpoContactsAssignment } from '@/queries/case';
import { useUnassignOpoCaseContactsMutation } from '@/queries/opobff';

export const useDetachOpoContact = ({ caseId, isOpoCase = false }: { caseId: Uuid; isOpoCase?: boolean }) => {
  const { mutateAsync: detachTxCase, isPending: isPendingTxCase } = useRemoveOpoContactsAssignment();
  const { mutateAsync: detachOpoCase, isPending: isPendingOpoCase } = useUnassignOpoCaseContactsMutation();

  const handleDetach = async (opoContactId: string) => {
    try {
      if (isOpoCase) {
        await detachOpoCase({ caseId, opoContactIds: [opoContactId] });
      } else {
        await detachTxCase({ caseId, contactIds: [opoContactId] });
      }
      toast.success('Resource has been successfully detached');
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  return { handleDetach, isPendingDetach: isOpoCase ? isPendingOpoCase : isPendingTxCase };
};
